import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { API_BASE_URL, getRequest, postRequest } from "../../../api";
import { avantageSocialRequestsSuccess, avantageSocialRequestsFailure, setAvantageSocialRequestsLoading } from "../actions/avantageSocialRequestActions";
const token = () => sessionStorage.getItem("token");
const message = (e, fallback) => e?.response?.data?.message || e?.message || fallback;
function* load(path, scope) {
    yield put(setAvantageSocialRequestsLoading(true));
    try { const response = yield call(getRequest, { url: `${API_BASE_URL}/api/avantage-social-requests/${path}`, token: token() }); yield put(avantageSocialRequestsSuccess(scope, response.data)); }
    catch (e) { yield put(avantageSocialRequestsFailure(message(e, "Impossible de charger les demandes d'avantages."))); }
    finally { yield put(setAvantageSocialRequestsLoading(false)); }
}
export function* fetchMyAvantageSocialRequestsSaga() { yield* load("mine", "myRequests"); }
export function* fetchManagerAvantageSocialInboxSaga() { yield* load("manager/inbox", "managerInbox"); }
export function* fetchAdminAvantageSocialInboxSaga() { yield* load("admin/inbox", "adminInbox"); }
export function* createAvantageSocialRequestSaga(action) {
    yield put(setAvantageSocialRequestsLoading(true));
    try {
        yield call(postRequest, { url: `${API_BASE_URL}/api/avantage-social-requests`, token: token(), data: action.payload });
        yield* load("mine", "myRequests");
        yield call([Swal, Swal.fire], { icon: "success", title: "Demande envoyée", text: "Votre demande d'avantage a été envoyée avec succès.", timer: 1800, showConfirmButton: false });
    }
    catch (e) {
        const errorMessage = message(e, "Impossible d'envoyer la demande.");
        yield put(avantageSocialRequestsFailure(errorMessage));
        yield call([Swal, Swal.fire], { icon: "error", title: "Demande non envoyée", text: errorMessage });
    }
    finally { yield put(setAvantageSocialRequestsLoading(false)); }
}
export function* decideAvantageSocialRequestSaga(action) {
    const { id, decision, comment, manager } = action.payload;
    const scope = manager ? "managerInbox" : "adminInbox";
    const path = manager ? "manager" : "admin";
    yield put(setAvantageSocialRequestsLoading(true));
    try { yield call(postRequest, { url: `${API_BASE_URL}/api/avantage-social-requests/${path}/${id}/decision`, token: token(), data: { decision, comment } }); yield* load(`${path}/inbox`, scope); }
    catch (e) { yield put(avantageSocialRequestsFailure(message(e, "Décision non enregistrée."))); }
    finally { yield put(setAvantageSocialRequestsLoading(false)); }
}
